<ion-app>
  <ion-router-outlet></ion-router-outlet>
  <ion-toast
    #errorToast
    icon="globe"
    position="middle"
    class="custom-toast"
    message="Что-то пошло не так, попробуйте позже..."
    [duration]="2000"
  ></ion-toast>

  <ion-toast
    #bankingDataError
    icon="close-circle-outline"
    position="middle"
    class="custom-toast"
    message="Для принятия заявки необходимо заполнить банковские реквизиты."
    [duration]="3000"
  ></ion-toast>

  <ng-container style="z-index: 999999999" #modalContainer></ng-container>
</ion-app>
